<template>
  <div class="chart-card">
    <div class="section-title">{{ label }}</div>
    <charts :options="chartOptions"></charts>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaOptionDistributionChart',
  props: {
    campo: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    rows: {
      type: Array,
      default: function () {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#26a69a'
    }
  },
  computed: {
    distribution () {
      const counts = {};

      this.rows.forEach((record) => {
        const answer = record.answers && record.answers[this.campo] ? record.answers[this.campo] : null;
        const values = this.multiple ? this.parseMultipleValues(answer) : this.parseSingleValue(answer);

        values.forEach((value) => {
          if (!counts[value]) {
            counts[value] = 0;
          }
          counts[value]++;
        });
      });

      return Object.keys(counts)
        .map((itemLabel) => ({ label: itemLabel, count: counts[itemLabel] }))
        .sort((left, right) => {
          if (left.count === right.count) {
            return left.label.localeCompare(right.label);
          }

          return right.count - left.count;
        });
    },
    chartOptions () {
      return {
        chart: {
          type: 'bar',
          height: 260,
          spacing: [0, 0, 0, 0]
        },
        title: {
          text: null
        },
        xAxis: {
          categories: this.distribution.map((item) => item.label),
          labels: {
            style: {
              color: '#6B7280'
            }
          }
        },
        yAxis: {
          title: {
            text: null
          },
          gridLineColor: '#EEF0F5'
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        series: [{
          name: this.label,
          data: this.distribution.map((item) => item.count),
          color: this.color
        }]
      };
    }
  },
  methods: {
    parseSingleValue (answer) {
      const value = this.normalizeValue(answer && answer.label ? answer.label : null);

      return value ? [value] : [];
    },
    parseMultipleValues (answer) {
      if (!answer) {
        return [];
      }

      const parsed = this.parseStructuredValue(answer.raw_value);
      if (parsed.length > 0) {
        return parsed;
      }

      const fallback = this.parseStructuredValue(answer.label);
      if (fallback.length > 0) {
        return fallback;
      }

      return this.parseSingleValue(answer);
    },
    parseStructuredValue (value) {
      if (value === null || value === undefined || value === '') {
        return [];
      }

      if (Array.isArray(value)) {
        return value.map((item) => this.normalizeValue(item)).filter(Boolean);
      }

      if (typeof value === 'object') {
        return Object.keys(value)
          .filter((key) => this.isTruthySelection(value[key]))
          .map((key) => this.normalizeValue(key))
          .filter(Boolean);
      }

      const normalized = String(value).trim();
      if (!normalized) {
        return [];
      }

      if ((normalized[0] === '[' && normalized[normalized.length - 1] === ']') || (normalized[0] === '{' && normalized[normalized.length - 1] === '}')) {
        try {
          return this.parseStructuredValue(JSON.parse(normalized));
        } catch (error) {
        }
      }

      if (/^(true|1|si|sí)$/i.test(normalized)) {
        return ['Sí'];
      }

      if (/^(false|0|no)$/i.test(normalized)) {
        return [];
      }

      return normalized
        .split(/[,;|]/)
        .map((item) => this.normalizeValue(item))
        .filter(Boolean);
    },
    isTruthySelection (value) {
      if (typeof value === 'boolean') {
        return value;
      }

      if (typeof value === 'number') {
        return value === 1;
      }

      return /^(true|1|si|sí|yes|on)$/i.test(String(value).trim());
    },
    normalizeValue (value) {
      if (value === null || value === undefined) {
        return null;
      }

      const normalized = String(value).trim();

      return normalized || null;
    }
  }
};
</script>

<style scoped>
.chart-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  min-height: 320px;
  padding: 20px 22px;
}

.section-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/OptionDistributionChart.vue